import React from 'react'
import moment from 'moment'
import { Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const DepositPaid = ({ payment }) => {
  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
        }}
      >
        <Typography
          sx={{
            color: '#42E93E',
            fontWeight: '700',
            letterSpacing: '0.46px',
            marginRight: '5px',
            textTransform: 'uppercase',
          }}
        >
          Paid:
        </Typography>
        <Typography
          sx={{
            fontWeight: '700',
            letterSpacing: '0.46px',
            marginRight: '5px',
            textTransform: 'capitalize',
          }}
        >
          {new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
          }).format(payment.amount)}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontWeight: '400',
            letterSpacing: '0.46px',
            textTransform: 'capitalize',
          }}
        >
          {moment(payment.payment_paid).format('DD/MM/YYYY HH:mm')}
        </Typography>
      </Grid>
    </React.Fragment>
  )
}

DepositPaid.propTypes = {
  payment: PropTypes.object,
}

export default DepositPaid
